<template>
  <div class="map mb-2" ref="map">
    <units-map-slot
      mode="drawing"
      :data="mapData"
      @circle-updated="onCircleUpdated"
    />
  </div>
</template>

<script>
import UnitsMapSlot
  from "@/views/components/GridView/layouts/slots/UnitsMapSlot/index.vue";
import axios from "@/libs/axios";

export default {
  name: "CameraMap",
  components: {UnitsMapSlot},
  props: {
    value: Array | Object,
  },
  data() {
    return {
      model: null,
      latField: "",
      lngField: "",
      mapData: null,
    };
  },
  created() {
    this.model = this.value || {};
    this.latField = this.model.lat || 19.442217319074633;
    this.lngField = this.model.lng || -99.12301328580936;
    this.radius = this.model.radius || 0;

    this.mapData = {
      drawingData: {
        lat: this.latField,
        lng: this.lngField,
        radius: this.radius,
        zoom: this.model.zoom || 5,
      },
    };
  },
  methods: {
    onCircleUpdated(event) {
      const action = event.action;
      const data = event.data;

      if (action === "updated") {
        this.latField = data.center.lat;
        this.lngField = data.center.lng;
        data.radius = data.radius ? parseFloat(data.radius).toFixed(2) : 2.0;
        this.model = {lat: data.center.lat, lng: data.center.lng, radius: data.radius};
        this.$emit("input", this.model);
        this.getNearbyDevices(this.model);
      } else {
        this.latField = "";
        this.lngField = "";
        this.$emit("input", {});
      }
    },
    getNearbyDevices(data) {
      if (!isNaN(data.radius) && !isNaN(data.lat) && !isNaN(data.lng)) {
        const lat = data.lat;
        const lng = data.lng;
        const radius = data.radius;
        const fields = "id,camera_id,camera_type,camera.name,units";
        const url = `/v1/services/device/get-nearby-devices?lat=${lat}&lng=${lng}&radius=${radius}&fields=${fields}`;

        this.$emit('loading-map-data', true);

        axios.get(url).then(({data}) => {
          const selectedCameras = data.data.map((resp) => {
            return {
              value: resp.camera_id,
              label: resp.name,
              camera: {
                id: resp.id,
                camera_id: resp.camera_id,
                camera_type: resp.camera_type,
                name: resp.name,
                units: resp.units,
                camera_proxy_id: resp.id,
                id_camera_proxy: resp.id,
              }
            };
          });

          if (selectedCameras.length) {
            this.$emit("camera-selection", selectedCameras);
          }
        })
        .finally(() => {
          this.$emit('loading-map-data', false);
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.map {
  height: 380px;
}
</style>
